<template>
  <div class="animated fadeIn mb-5" v-if="!loading">
    <basic-heading v-if="schedule" class="print-hidden">
      <span class="float-left mr-2">{{ schedule.name() }} Grinding Order</span>
      <!--<template #right-content>
         <header-button-group
          :button_config="button_config"
        ></header-button-group> 
      </template>-->
    </basic-heading>

    <!--    <b-row class="my-4">-->
    <!--      <b-col>-->
    <!--        <b-overlay :show="downloading" spinner-small spinner-variant="info">-->
    <!--          <action-button variant="info" icon="download" label="Download Results CSV" @click="download()"></action-button>-->
    <!--        </b-overlay>-->
    <!--        <schedule-process-download :process_schedule="schedule.getProcessSchedules().first()" ref="processDownload"></schedule-process-download>-->
    <!--      </b-col>-->
    <!--      <b-col>-->
    <!--        <b-overlay :show="uploading" spinner-small spinner-variant="info">-->
    <!--          <action-button variant="info" icon="upload" label="Upload Results" @click="upload()"></action-button>-->
    <!--        </b-overlay>-->
    <!--        <schedule-process-upload-->
    <!--          :process_schedule="schedule.getProcessSchedules().first()"-->
    <!--          ref="processUpload"-->
    <!--          @onUpload="uploading = true"-->
    <!--          @onUploadSuccess="uploading = false"-->
    <!--          @onUploadFailure="uploading = false"-->
    <!--        ></schedule-process-upload>-->
    <!--      </b-col>-->
    <!--      <b-col><action-button variant="info" icon="table" label="Manual Enter Results" :to="'/schedules/'+schedule.id+'/results'"></action-button></b-col>-->
    <!--      <b-col><action-button variant="info" icon="print" label="Print Paper Worksheet"></action-button></b-col>-->
    <!--    </b-row>-->

    <b-row class="mt-4 print-hidden">
      <b-col>
        <b-select
          :options="opts__instrument_instances"
          v-model="selected__instrument_instance"
        ></b-select>
      </b-col>
    </b-row>

    <div v-if="process_schedule && instrument_instance">
      <schedule-grinding-table
        :process_schedule="process_schedule"
        :instrument_instance="instrument_instance"
      ></schedule-grinding-table>
    </div>
    <div v-else>
      <b-alert show class="mt-4 print-hidden"
        >Please select an available instrument for this schedule.</b-alert
      >
    </div>
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import GeneralTile from "../../../components/shared/GeneralTile";
import LinkTile from "../../../components/shared/LinkTile";
import ActionButton from "../../../components/shared/ActionButton";
import ScheduleModel from "../../../models/lab/ScheduleModel";
import ScheduleGrindingTable from "../../../components/lab/schedule/ScheduleGrindingTable";

export default {
  name: "GrindingOrderDetail",
  components: {
    ScheduleGrindingTable,
    ActionButton,
    LinkTile,
    GeneralTile,
    BasicHeading,
    HeaderButtonGroup,
  },
  props: {
    model: {
      type: ScheduleModel,
      default: () => null,
    },
    schedule_id: {
      type: String,
      default: () => null,
    }
  },
  data() {
    return {
      loading: true,
      id: this.$route.params.schedule_id || this.schedule_id,

      schedule: null,
      process_schedule: null,
      instrument_instances: null,
      instrument_instance: null,

      opts__instrument_instances: [],
      selected__instrument_instance: null,
    };
  },
  computed: {
    /**
     * Header button configuration
     */
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-arrow-left",
            linkto: "/schedules/" + this.id,
            title: "Go Back",
          },
        ],
      };
    },
  },
  methods: {
    init() {
      this.loading = true;
      let init = [];
      init.push(this.fetch());
      return Promise.all(init).then(() => {
        this.populate();
        this.loading = false;
      });
    },
    fetch() {
      if (this.model) {
        return new Promise(() => {
          return (this.schedule = this.model);
        });
      } else if (this.id) {
        let schedule = new ScheduleModel({ id: this.id });
        return schedule.fetch().then(() => {
          return (this.schedule = schedule);
        });
      }
    },
    populate() {
      this.process_schedule = this.schedule.getProcessSchedules().first();
      
      if (this.process_schedule && this.process_schedule.id) {
        this._process_instrument_instances =
          this.process_schedule.getProcessScheduleInstrumentInstances();
        this.opts__instrument_instances = [];
        this._process_instrument_instances.each((process_instrument_instance) => {
          this.instrument_instance = process_instrument_instance.instrument_instance;
          if (process_instrument_instance.instrument_instance) {
            this.opts__instrument_instances.push({
              value: process_instrument_instance.instrument_instance_id,
              text: process_instrument_instance.instrument_instance.name,
            });
          }
        });
      }
    },
  },
  watch: {
    selected__instrument_instance() {
      console.log(this.selected__instrument_instance)
      if (!this._process_instrument_instances) {
        return;
      }
      
      this._process_instrument_instances.each((instance) => {
        if (this.selected__instrument_instance === instance.id) {
          this.instrument_instance = instance;
        }
      });
    },
  },
  created() {
    this.init();
  },
};
</script>
